import { Column, Container, Row, Text } from "@react-email/components";
import useThemeContextualColors, {
  sectionToParent,
} from "../../hooks/use-theme-contextual-colors";
import type { AddressBlockProps } from "./types";
import { useVariablesValues } from "../../lib/variables-context";
import { tLayout } from "../../translations";

export function AddressBlockEmail({
  theme,
  section,
  locale,
  defaultLocale,
}: AddressBlockProps) {
  const t = tLayout(locale, defaultLocale);
  const colors = useThemeContextualColors(theme, sectionToParent(section));
  const { getVariableValue } = useVariablesValues();

  // Not perfect, but prevents the block from being displayed when the pickup point is not set
  // packages/editor-blocks-library/src/blocks/pickup-point/email.tsx
  // const isPickupPointBlockShown =
  //   getVariableValue("address.isPickupPoint") === true &&
  //   getVariableValue("pickupPoint.addressLine1")?.length;

  return (
    <Container>
      <Row style={{ color: colors.text }}>
        <Column
          style={{ width: "50%", verticalAlign: "top", paddingRight: "12px" }}
        >
          <Text
            style={{
              fontWeight: "bold",
              lineHeight: "1.3",
              marginBottom: "2px",
              marginTop: "0",
              fontSize: "12px",
            }}
          >
            {getVariableValue("address.isPickupPoint") === true
              ? t("deliveryAddress.titlePickup")
              : t("deliveryAddress.title")}
          </Text>
          {getVariableValue("address.isPickupPoint") !== true && (
            <Text style={{ margin: "0", lineHeight: "1.3", fontSize: "11px" }}>
              {getVariableValue("customer.firstName")}{" "}
              {getVariableValue("customer.lastName")}
            </Text>
          )}
          <Text style={{ margin: "0", lineHeight: "1.3", fontSize: "11px" }}>
            {getVariableValue("address.address1")}
            {getVariableValue("address.address2") &&
              `, ${getVariableValue("address.address2")}`}
          </Text>
          <Text style={{ margin: "0", lineHeight: "1.3", fontSize: "11px" }}>
            {getVariableValue("address.zip")} {getVariableValue("address.city")}
            , {getVariableValue("address.country")}
          </Text>
        </Column>

        <Column
          style={{ width: "50%", verticalAlign: "top", paddingLeft: "12px" }}
        >
          <Text
            style={{
              fontWeight: "bold",
              lineHeight: "1.3",
              marginBottom: "2px",
              marginTop: "0",
              fontSize: "12px",
            }}
          >
            {t("deliveryAddress.orderDetails.title")}
          </Text>
          <Text style={{ margin: "0", lineHeight: "1.3", fontSize: "11px" }}>
            {t("deliveryAddress.orderDetails.trackingNumber")}{" "}
            {getVariableValue("parcel.trackingId") || "N/A"}
          </Text>
          <Text
            style={{
              margin: "0",
              lineHeight: "1.3",
              fontSize: "11px",
              textDecoration: "underline",
            }}
          >
            {t("deliveryAddress.orderDetails.orderNumber")}{" "}
            {getVariableValue("parcel.orderNumber") || "N/A"}
          </Text>
        </Column>
      </Row>

      {/*<Row>
       <Column style={{ textAlign: "center" }}>
       <Text style={{ margin: "0", lineHeight: "1.6" }}>
       {parcel.carrier?.name || "Carrier"}
       </Text>
       </Column>
       </Row>*/}
    </Container>
  );
}
